import React from 'react';
import PropTypes from 'prop-types';

const SvgLineThickness = ({ active, ...props }) => {
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <rect
                width=".833"
                height="24"
                x="1"
                y="1"
                fill={strokeColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                rx=".417"
            />
            <path
                fill={strokeColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                d="M7.056 1.5a.5.5 0 0 1 .5-.5h.666a.5.5 0 0 1 .5.5v23a.5.5 0 0 1-.5.5h-.666a.5.5 0 0 1-.5-.5v-23Z"
            />
            <rect
                width="2.5"
                height="24"
                x="13.944"
                y="1"
                fill={strokeColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                rx=".5"
            />
            <path
                fill={strokeColor}
                stroke={strokeColor}
                strokeWidth="1.25"
                d="M21.666 1.5a.5.5 0 0 1 .5-.5H24.5a.5.5 0 0 1 .5.5v23a.5.5 0 0 1-.5.5h-2.334a.5.5 0 0 1-.5-.5v-23Z"
            />
        </svg>
    );
};
SvgLineThickness.propTypes = {
    active: PropTypes.bool,
};
SvgLineThickness.defaultProps = {
    active: false,
};

export default SvgLineThickness;
